import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=32ee6937&scoped=true&"
import script from "./ProcessFDDOC.vue?vue&type=script&lang=js&"
export * from "./ProcessFDDOC.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=32ee6937&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee6937",
  null
  
)

export default component.exports